import * as React from 'react';
import styled from 'styled-components';

import { ModuleSocialEmbed } from '@packages/common';
import { usePinterest } from './PinterestEmbed.utils';

// && was put on purpose to raise specificity
export const Container = styled.div`
  overflow: hidden;
  text-align: center;

  && > * {
    max-width: none;
  }
`;

export type PinterestEmbedProps = ModuleSocialEmbed;

export const PinterestEmbed: React.FC<PinterestEmbedProps> = ({ embedCode }) => {
  usePinterest(embedCode);
  return (
    <Container>
      <a data-pin-do="embedPin" href={`https://www.pinterest.com/pin/${embedCode}`} />
    </Container>
  );
};
